import { Component, OnInit, Input } from '@angular/core';
import { NbThemeService, NbCalendarRange } from '@nebular/theme';
import { LenguageService } from '../../../@core/utils/lenguage.service'

@Component({
  selector: 'ngx-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {
  data: [];
  loading: boolean = false;
  themeSubscription: any;
  @Input() id: string;
  @Input() title: string;
  @Input() type: string;
  @Input() dateStart: number;
  @Input() dateEnd: number

  multi = [
  ];
  showLegend = true;
  showXAxis = true;
  showYAxis = true;
  showXAxisLabel = true;
  xAxisLabel = 'Data';
  showYAxisLabel = true;
  yAxisLabel = 'Population';
  colorScheme: any;


  ngOnInit() {
    this.yAxisLabel = this.title
    this.getData()
  }

  ngOnChanges() {
    this.getData()
  }

  constructor(private theme: NbThemeService,
    public language: LenguageService,
  ) {
    this.themeSubscription = this.theme.getJsTheme().subscribe(config => {
      const colors: any = config.variables;
      this.colorScheme = {
        domain: [colors.primaryLight, colors.successLight, colors.warningLight, colors.dangerLight, colors.infoLight],
      };
    });
  }



  async getData() {
    this.loading = true;

    try {
      this.data = [];
    } finally {
      this.loading = false
    }
    console.log(this.data);
    let prev = {};

    this.data.map((d: any) => {
      d.data.map((s: any) => {
        if (prev[s.user]) {
          prev[s.user].series.push({
            name: d.date,
            value: s.number
          })
        } else {
          prev[s.user] = {
            name: s.user,
            series: [{
              name: d.date,
              value: s.number
            }]
          }
        }
      })
    })
    console.log(prev);
    this.multi = Object.keys(prev).map(k => { return prev[k] })

    this.loading = false;
  }

}
